
import { computed, defineComponent, reactive, ref, watch } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useRoute } from 'vue-router';
import SvgIcon from '@/components/Icons/SvgIcon.vue';
import UpdPassWord from '@/components/UpdPassWord/index.vue';
import { PasswordStateEnum, FILESERVICE } from '@/config/defaultSetting';
import { removeToken } from '@/utils/auth';
import {
  UserApiSerivce,
  IUpdatePasswordwithCode,
  IVerifiCation,
} from '@/api/user';
import { ElMessage } from 'element-plus';

const __default__ = defineComponent({
  name: 'Login',
  components: {
    SvgIcon,
    UpdPassWord,
  },
  setup() {
    const userStore = useUserStore();
    const route = useRoute();
    const dialogVisible = ref<boolean>(false);
    const loginLoading = ref<boolean>(false);
    const passwordPattern = ref<string>('');
    const passwordMessage = ref<string>('');
    const dialogTitle = ref<string>('修改密码');

    let loginData: {
      userName: string;
      password: string;
      mobile: string;
      code: string;
      newPassword: string;
      checkPass: string;
    } = reactive({
      userName: '',
      password: '',
      mobile: '',
      code: '',
      newPassword: '',
      checkPass: '',
    });

    const fourPLBackgroundUrl = `url(${FILESERVICE}/file/4pl/webclient/img/4pl_login_background.png)`;
    const tMSBackgroundUrl = `url(${FILESERVICE}/file/4pl/webclient/img/tms_login_background.png)`;
    const oDSBackgroundUrl = `url(${FILESERVICE}/file/4pl/webclient/img/ods_login_background.png)`;
    const redirectUrl = route.query.redirectUrl ? route.query.redirectUrl : '';
    const urlCode = computed(() => {
      if ((redirectUrl as string).includes('tms')) {
        return 'tms';
      } else if ((redirectUrl as string).includes('ods')) {
        return 'ods';
      } else if ((redirectUrl as string).includes('fpl')) {
        return 'fpl';
      } else {
        return '4pl';
      }
    });

    const targetUrl = ref<undefined | string>(undefined);

    const loginTitle = computed(() => {
      if (urlCode.value === 'ods') {
        return '4PL-ODS订单调度中心';
      } else if (urlCode.value === 'tms') {
        return '4PL-TMS协同平台';
      } else if (urlCode.value === 'fpl') {
        return '4PL-FPL平台';
      } else {
        return '4PL物流协同平台';
      }
    });

    const backgroundClass = computed(() => {
      if (urlCode.value === 'ods') {
        return 'ODSBackground';
      } else if (urlCode.value === 'tms') {
        return 'TMSBackground';
      } else {
        return 'FourPLBackground';
      }
    });
    const TitleClass = computed(() => {
      if (urlCode.value === 'tms') {
        return 'TMStitleColor';
      } else {
        return '';
      }
    });
    const dataRule = reactive({
      userName: [
        {
          type: 'string',
          message: '请确认账号格式是否正确',
          trigger: 'blur',
        },
        { required: true, message: '请输入账号', trigger: 'blur' },
        { max: 15, message: '账号位数过长', trigger: 'blur' },
      ],
      password: [
        {
          type: 'string',
          message: '请确认密码格式是否正确',
          trigger: 'blur',
        },
        { required: true, message: '请输入密码', trigger: 'blur' },
        { max: 20, message: '密码位数过长', trigger: 'blur' },
      ],
      code: [{ required: true, validator: regularCode, trigger: 'blur' }],
      mobile: [{ validator: regularMobile, trigger: 'blur' }],
      newPassword: [
        {
          required: true,
          pattern: '',
          message: '',
        },
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
      checkPass: [
        {
          required: true,
          validator: validatePass2,
          trigger: 'blur',
        },
      ],
    });

    const forgetPassFlag = ref(false);
    const verificationCodeFlag = ref(false);
    const countDown = ref(60);
    const countDownHidden = false;
    const ruleForm = ref();
    const regularTitle = ref('');

    watch(route, () => {
      forgetPassFlag.value = false;
      verificationCodeFlag.value = false;
      loginData.userName = '';
      loginData.password = '';
      loginData.mobile = '';
      loginData.code = '';
      loginData.newPassword = '';
      loginData.checkPass = '';
    });

    function regularMobile(rule: any, value: any, callback: any) {
      if (
        !/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(
          value
        )
      ) {
        callback(new Error('请输入正确手机号'));
      } else {
        callback();
      }
    }
    function regularCode(rule: any, value: any, callback: any) {
      if (!loginData.mobile) {
        ruleForm.value.validateField('mobile');
      }
      callback();
    }

    function validatePass(rule: any, value: any, callback: any) {
      if (!value) {
        callback(new Error('请输入新密码'));
      } else {
        if (loginData.checkPass) {
          ruleForm.value.validateField('checkPass');
        }
        callback();
      }
    }

    function validatePass2(rule: any, value: any, callback: any) {
      if (!value) {
        callback(new Error('请再次确认密码'));
      } else {
        if (value !== loginData.newPassword) {
          callback(new Error('两次密码不一致,请重新输入'));
        }
        callback();
      }
    }

    function onClose() {
      dialogVisible.value = false;
    }

    function getPasswordPolicy() {
      UserApiSerivce.getPasswordPolicy().then((result) => {
        dataRule.newPassword.splice(0, 1, {
          required: true,
          pattern: result[0].regexp,
          message: result[0].regexpTips,
        });
        regularTitle.value = result[0].regexpTips;
      });
    }

    return {
      FILESERVICE,
      fourPLBackgroundUrl,
      tMSBackgroundUrl,
      oDSBackgroundUrl,
      userStore,
      loginData,
      loginLoading,
      backgroundClass,
      TitleClass,
      passwordPattern,
      passwordMessage,
      dialogVisible,
      dialogTitle,
      urlCode,
      loginTitle,
      targetUrl,
      redirectUrl,
      forgetPassFlag,
      verificationCodeFlag,
      countDown,
      countDownHidden,
      dataRule,
      ruleForm,
      regularTitle,
      getPasswordPolicy,
      onClose,
    };
  },
  methods: {
    async onLogin() {
      this.loginLoading = true;
      this.getTargetUrl();

      try {
        const resolve = await this.userStore.login(
          {
            userName: this.loginData.userName,
            password: window.btoa(this.loginData.password),
          },
          this.targetUrl
        );
        if (!resolve.token) {
          window.location.href = resolve.redirectUrl
            ? resolve.redirectUrl
            : '/';
        } else {
          const result = await this.userStore.checkPassword({
            userName: this.loginData.userName,
            password: window.btoa(this.loginData.password),
          });

          // 保存用户浏览器信息
          // await UserApiSerivce.saveClientScreenInfo({
          //   windowScreenHeight: window.screen.height,
          //   windowScreenWidth: window.screen.width,
          //   windowScreenAvailHeight: window.screen.availHeight,
          //   windowScreenAvailWidth: window.screen.availWidth,
          //   windowInnerHeight: window.innerHeight,
          //   windowInnerWidth: window.innerWidth,
          //   userAgent: navigator.userAgent,
          // });
          this.loginLoading = false;
          if (result.warningType === PasswordStateEnum.WEAKPASSWORD) {
            this.loginData.password = '';
            this.dialogVisible = true;
            removeToken();
          } else if (result.warningType === PasswordStateEnum.EXPIRED) {
            this.loginData.password = '';
            this.userStore.resetState();
          } else {
            try {
              await this.userStore.fplLogin({
                userName: this.loginData.userName,
                password: window.btoa(this.loginData.password),
              });
            } catch (e) {
              throw new Error('外部系统setCookie接口调用失败' + e);
            } finally {
              window.location.href = resolve.redirectUrl
                ? resolve.redirectUrl
                : '/';
            }
          }
        }
      } catch {
        this.loginLoading = false;
      }
      this.loginLoading = false;
    },
    getTargetUrl() {
      if (this.redirectUrl) {
        this.targetUrl = this.redirectUrl as string;
      } else {
        if (this.urlCode === 'ods') {
          this.targetUrl = process.env.VUE_APP_ODS_SERVERS_URL;
        } else if (this.urlCode === 'tms') {
          this.targetUrl = process.env.VUE_APP_TMS_SERVERS_URL;
        } else if (this.urlCode === 'fpl') {
          this.targetUrl = process.env.VUE_APP_FPL_DEFAULT_SERVERS_URL;
        }
      }
    },
    onDialogClose(value: boolean) {
      this.dialogVisible = value;
    },
    goLogisticalReceiving() {
      window.open(
        `${process.env.VUE_APP_TMS_SERVERS_URL}#/wms/inbound/receiving/LogisticalReceiving`,
        '_blank'
      );
    },
    onOpenCL() {
      window.open('https://srmportal.linshimuye.com/', '_blank');
    },
    forgetPassword() {
      this.forgetPassFlag = true;
    },
    onVerifyCode(ruleForm: any) {
      let initData: IVerifiCation = {
        username: this.loginData.userName,
        mobile: this.loginData.mobile,
        verifyCode: this.loginData.code,
      };
      ruleForm.validate(async (valid: any) => {
        if (valid) {
          UserApiSerivce.verifiCation(initData)
            .then(() => {
              this.forgetPassFlag = false;
              this.verificationCodeFlag = true;
              this.getPasswordPolicy();
            })
            .catch((err) => {
              throw new Error(err);
            });
        }
      });
    },
    onChangePassword(ruleForm: any) {
      let initData: IUpdatePasswordwithCode = {
        verifyCode: this.loginData.code,
        mobile: this.loginData.mobile,
        password: window.btoa(this.loginData.newPassword),
        passwordRe: window.btoa(this.loginData.checkPass),
      };
      ruleForm.validate(async (valid: any) => {
        if (valid) {
          UserApiSerivce.updatePassword(initData)
            .then(() => {
              ElMessage.success({
                message: '修改成功',
                type: 'success',
              });
              this.forgetPassFlag = false;
              this.verificationCodeFlag = false;
            })
            .catch((err) => {
              throw new Error(err);
            });
        }
      });
    },
    async getCode() {
      if (
        !/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(
          this.loginData.mobile
        )
      ) {
        this.ruleForm.validateField('mobile');
        return;
      }
      if (this.countDown === 60) {
        this.countDownHidden = true;
        try {
          await UserApiSerivce.createCode(this.loginData.mobile);
        } catch (error) {
          throw new Error(error as any);
        }
        let codeTime = setInterval(() => {
          this.countDown--;
          if (this.countDown < 1) {
            clearInterval(codeTime);
            this.countDownHidden = false;
            this.countDown = 60;
          }
        }, 1000);
        this.$forceUpdate();
      }
    },
    onReturnLoign() {
      this.forgetPassFlag = false;
      this.verificationCodeFlag = false;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e29fd646": (_ctx.fourPLBackgroundUrl),
  "73216d29": (_ctx.tMSBackgroundUrl),
  "3add48f6": (_ctx.oDSBackgroundUrl)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__